"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workingGroupTypes = exports.RewardPaymentType = exports.Opening = exports.OpeningType = exports.OpeningTypeDef = exports.OpeningType_Regular = exports.OpeningType_Leader = exports.Penalty = exports.ApplyOnOpeningParameters = exports.StakeParameters = exports.StakePolicy = exports.WorkerInfo = exports.Worker = exports.ApplicationInfo = exports.Application = exports.ApplicationIdToWorkerIdMap = exports.ApplicationIdSet = exports.StorageProviderId = exports.WorkerId = exports.OpeningId = exports.ApplicationId = void 0;
const types_1 = require("@polkadot/types");
const primitive_1 = require("@polkadot/types/primitive");
const common_1 = require("../common");
class ApplicationId extends primitive_1.u64 {
}
exports.ApplicationId = ApplicationId;
class OpeningId extends primitive_1.u64 {
}
exports.OpeningId = OpeningId;
class WorkerId extends common_1.ActorId {
}
exports.WorkerId = WorkerId;
class StorageProviderId extends WorkerId {
}
exports.StorageProviderId = StorageProviderId;
class ApplicationIdSet extends types_1.BTreeSet.with(ApplicationId) {
}
exports.ApplicationIdSet = ApplicationIdSet;
class ApplicationIdToWorkerIdMap extends types_1.BTreeMap.with(ApplicationId, WorkerId) {
}
exports.ApplicationIdToWorkerIdMap = ApplicationIdToWorkerIdMap;
class Application extends (0, common_1.JoyStructDecorated)({
    role_account_id: common_1.AccountId,
    reward_account_id: common_1.AccountId,
    staking_account_id: common_1.AccountId,
    member_id: common_1.MemberId,
    description_hash: types_1.Bytes,
    opening_id: OpeningId,
}) {
}
exports.Application = Application;
class ApplicationInfo extends (0, common_1.JoyStructDecorated)({
    application_id: ApplicationId,
    application: Application,
}) {
}
exports.ApplicationInfo = ApplicationInfo;
class Worker extends (0, common_1.JoyStructDecorated)({
    member_id: common_1.MemberId,
    role_account_id: common_1.AccountId,
    staking_account_id: common_1.AccountId,
    reward_account_id: common_1.AccountId,
    started_leaving_at: types_1.Option.with(primitive_1.u32),
    job_unstaking_period: primitive_1.u32,
    reward_per_block: types_1.Option.with(primitive_1.u128),
    missed_reward: types_1.Option.with(primitive_1.u128),
    created_at: primitive_1.u32,
}) {
    // FIXME: Won't be needed soon?
    get is_active() {
        return !this.isEmpty;
    }
}
exports.Worker = Worker;
class WorkerInfo extends (0, common_1.JoyStructDecorated)({
    worker_id: WorkerId,
    worker: Worker,
}) {
}
exports.WorkerInfo = WorkerInfo;
class StakePolicy extends (0, common_1.JoyStructDecorated)({
    stake_amount: primitive_1.u128,
    leaving_unstaking_period: primitive_1.u32,
}) {
}
exports.StakePolicy = StakePolicy;
class StakeParameters extends (0, common_1.JoyStructDecorated)({
    stake: primitive_1.u128,
    staking_account_id: common_1.AccountId,
}) {
}
exports.StakeParameters = StakeParameters;
class ApplyOnOpeningParameters extends (0, common_1.JoyStructDecorated)({
    member_id: common_1.MemberId,
    opening_id: OpeningId,
    role_account_id: common_1.AccountId,
    reward_account_id: common_1.AccountId,
    description: types_1.Bytes,
    stake_parameters: StakeParameters,
}) {
}
exports.ApplyOnOpeningParameters = ApplyOnOpeningParameters;
class Penalty extends (0, common_1.JoyStructDecorated)({
    slashing_text: types_1.Text,
    slashing_amount: primitive_1.u128,
}) {
}
exports.Penalty = Penalty;
class OpeningType_Leader extends primitive_1.Null {
}
exports.OpeningType_Leader = OpeningType_Leader;
class OpeningType_Regular extends primitive_1.Null {
}
exports.OpeningType_Regular = OpeningType_Regular;
exports.OpeningTypeDef = {
    Leader: OpeningType_Leader,
    Regular: OpeningType_Regular,
};
class OpeningType extends (0, common_1.JoyEnum)(exports.OpeningTypeDef) {
}
exports.OpeningType = OpeningType;
class Opening extends (0, common_1.JoyStructDecorated)({
    opening_type: OpeningType,
    created: primitive_1.u32,
    description_hash: types_1.Bytes,
    stake_policy: StakePolicy,
    reward_per_block: types_1.Option.with(primitive_1.u128),
    creation_stake: primitive_1.u128,
}) {
}
exports.Opening = Opening;
// Reward payment type enum.
class RewardPaymentType extends (0, common_1.JoyEnum)({
    MissedReward: primitive_1.Null,
    RegularReward: primitive_1.Null,
}) {
}
exports.RewardPaymentType = RewardPaymentType;
exports.workingGroupTypes = {
    ApplicationId,
    Application,
    ApplicationInfo,
    ApplicationIdSet,
    ApplicationIdToWorkerIdMap,
    WorkerId,
    Worker,
    WorkerInfo,
    Opening,
    OpeningId,
    StakePolicy,
    StakeParameters,
    StorageProviderId,
    OpeningType,
    ApplyOnOpeningParameters,
    Penalty,
    RewardPaymentType,
};
exports.default = exports.workingGroupTypes;
